(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-product-configurator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-b2b-section]').forEach((sectionRoot) => {
  if (sectionRoot.dataset.initialized === 'true') return;
  sectionRoot.dataset.initialized = 'true';
  const root = sectionRoot.querySelector('[data-b2b-configurator]');
  if (!root) return;
  const setPressed = (buttons, active) => buttons.forEach((button) => button.setAttribute('aria-pressed', button === active ? 'true' : 'false'));
  const fabricButtons = [...root.querySelectorAll('[data-fabric]')];
  const colorButtons = [...root.querySelectorAll('[data-color]')];
  const quantityButtons = [...root.querySelectorAll('[data-quantity]')];
  const customizations = [...root.querySelectorAll('[data-customization]')];
  const fabricInput = sectionRoot.querySelector('[data-input-fabric]');
  const tierInput = sectionRoot.querySelector('[data-input-tier]');
  const compositionInput = sectionRoot.querySelector('[data-input-composition]');
  const costInput = sectionRoot.querySelector('[data-input-cost]');
  const colorInput = sectionRoot.querySelector('[data-input-color]');
  const quantityInput = sectionRoot.querySelector('[data-input-quantity]');
  const customizationInput = sectionRoot.querySelector('[data-input-customization]');
  const fabricSummary = sectionRoot.querySelector('[data-summary-fabric]');
  const colorSummary = sectionRoot.querySelector('[data-summary-color]');
  const quantitySummary = sectionRoot.querySelector('[data-summary-quantity]');
  fabricButtons.forEach((button) => button.addEventListener('click', () => {
    setPressed(fabricButtons, button);
    if (fabricInput) fabricInput.value = button.dataset.fabric || '';
    if (tierInput) tierInput.value = button.dataset.tier || '';
    if (compositionInput) compositionInput.value = button.dataset.composition || '';
    if (costInput) costInput.value = button.dataset.cost || '';
    if (fabricSummary) fabricSummary.textContent = button.dataset.fabric || 'To be confirmed';
  }));
  colorButtons.forEach((button) => button.addEventListener('click', () => {
    setPressed(colorButtons, button);
    if (colorInput) colorInput.value = button.dataset.color || '';
    if (colorSummary) colorSummary.textContent = button.dataset.color || '';
  }));
  quantityButtons.forEach((button) => button.addEventListener('click', () => {
    setPressed(quantityButtons, button);
    if (quantityInput) quantityInput.value = button.dataset.quantity || '';
    if (quantitySummary) quantitySummary.textContent = button.dataset.quantity || '';
  }));
  const syncCustomizations = () => {
    const selected = customizations.filter((input) => input.checked).map((input) => input.value);
    if (customizationInput) customizationInput.value = selected.length ? selected.join(', ') : 'None selected';
  };
  customizations.forEach((input) => input.addEventListener('change', syncCustomizations));
  syncCustomizations();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-product-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-atelier-product]').forEach((root) => {
  if (root.dataset.atelierReady === 'true') return;
  root.dataset.atelierReady = 'true';

  const mainImage = root.querySelector('[data-atelier-main-image]');
  const thumbs = Array.from(root.querySelectorAll('[data-atelier-thumb]'));
  const swatches = Array.from(root.querySelectorAll('[data-colour-image], .atelier-product__swatch'));

  const setMain = (url) => {
    if (!mainImage || !url) return;
    mainImage.src = url;
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      setMain(thumb.dataset.image);
    });
  });

  swatches.forEach((swatch) => {
    swatch.addEventListener('click', () => {
      root.querySelectorAll('.atelier-product__swatch').forEach((item) => item.classList.remove('is-active'));
      swatch.classList.add('is-active');
      if (swatch.dataset.colourImage) setMain(swatch.dataset.colourImage);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }


  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
